export const Dot = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#6B7280" />
  </svg>
);

export const SelectedDot = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
  >
    <circle cx="2" cy="2" r="2" fill="#31c48d" />
  </svg>
);

export const PhotoIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1984 18.4996H20.0075L19.6457 17.776L16.0457 10.576L15.5984 9.68158L15.1512 10.576L13.1984 14.4816L10.0457 8.176L9.59844 7.28158L9.15122 8.176L4.35122 17.776L3.98942 18.4996H4.79844H19.1984ZM3.45493 4.65611C3.81125 4.29979 4.29453 4.09961 4.79844 4.09961H19.1984C19.7023 4.09961 20.1856 4.29979 20.5419 4.65611C20.8983 5.01243 21.0984 5.4957 21.0984 5.99961V17.9996C21.0984 18.5035 20.8983 18.9868 20.5419 19.3431C20.1856 19.6994 19.7023 19.8996 19.1984 19.8996H4.79844C4.29453 19.8996 3.81125 19.6994 3.45493 19.3431C3.09862 18.9868 2.89844 18.5035 2.89844 17.9996V5.99961C2.89844 5.4957 3.09862 5.01243 3.45493 4.65611Z"
      fill="#674F82"
      stroke="#674F82"
    />
  </svg>
);
